import {types, flow} from 'mobx-state-tree'

import {URL_API} from './globals'

const Location = types.model('Location', {
  uuid: types.identifier,
  longitude: types.number,
  latitude: types.number,
  timestamp: types.number,
  provider: types.string,
  speed: types.number,
  accuracy: types.number,
  imei: types.string,
})

const LocationStore = types
  .model('LocationStore', {
    locations: types.optional(types.array(Location), []),
    imei: types.optional(types.string, 'fa4623894a2160b4'),
    startdate: types.optional(types.number, 1631826000000),
    enddate: types.optional(types.number, 1631912399000),
  })
  .views(self => ({
    get getData() {
      return self.locations.filter(
        item =>
          item.timestamp >= self.startdate &&
          item.timestamp <= self.enddate &&
          item.imei === self.imei,
      )
    },
  }))
  .actions(self => ({
    getFetch: flow(function* () {
      try {
        const response = yield fetch(`${URL_API}/api/getlocs`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            imei: self.imei,
            startdate: self.startdate,
            enddate: self.enddate,
          }),
        })
        const json = yield response.json()
        for (const item of json.data) {
          self.locations.push({
            uuid: item.uuid,
            longitude: item.longitude,
            latitude: item.latitude,
            provider: item.provider,
            timestamp: item.timestamp,
            speed: item.speed,
            accuracy: item.accuracy,
            imei: item.imei,
          })
        }
      } catch (error) {
        console.error('Ошибка:', error)
      }
    }),
    clearData() {
      self.locations.clear()
    },
  }))

export default LocationStore
